module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-backdrop"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "Ierror"
  }, [_c('span', {
    staticClass: "cha",
    on: {
      "click": _vm.cha
    }
  }, [_vm._v("×")]), _vm._v(" "), (_vm.orderList) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newConstruction),
      expression: "newConstruction"
    }]
  }, [_c('h1', {
    staticClass: "LHeader"
  }, [_vm._v("选择报名人")]), _vm._v(" "), _c('ul', {
    staticClass: "listcontent"
  }, [_c('li', [_c('div', {
    staticClass: "jiang"
  }, [_c('Icon', {
    attrs: {
      "type": "checkmark-round"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "jiang"
  }, [_c('Icon', {
    attrs: {
      "type": "checkmark-round"
    }
  })], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "jiang"
  }, [_c('Icon', {
    attrs: {
      "type": "checkmark-round"
    }
  })], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "jiang"
  }, [_c('Icon', {
    attrs: {
      "type": "checkmark-round"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("确定")]), _vm._v(" "), _c('div', {
    staticClass: "new-construction"
  }, [_c('span', {
    on: {
      "click": _vm.Construction
    }
  }, [_vm._v("新建报名人")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newConstruction),
      expression: "!newConstruction"
    }]
  }, [_c('h1', {
    staticClass: "LHeader"
  }, [_vm._v("添加报名人")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "new-btn",
    on: {
      "click": _vm.newBtn
    }
  }, [_vm._v("提交")])])] : _vm._e(), _vm._v(" "), (_vm.contactsList) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newConstruction),
      expression: "newConstruction"
    }]
  }, [_c('h1', {
    staticClass: "LHeader"
  }, [_vm._v("选择联系人")]), _vm._v(" "), (_vm.linkmanList) ? _c('ul', {
    staticClass: "listcontent"
  }, _vm._l((_vm.linkmanList), function(item, index) {
    return _c('li', [_c('div', {
      staticClass: "jiang",
      on: {
        "click": function($event) {
          _vm.linkmanListPitch(index)
        }
      }
    }, [(index === _vm.linkmanListTrue) ? _c('Icon', {
      attrs: {
        "type": "checkmark-round"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "message"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("capitalize")(item.phone ? item.phone : '')))])]), _vm._v(" "), _c('div', {
      staticClass: "img",
      on: {
        "click": function($event) {
          _vm.compileConstruction(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/redact.png"),
        "alt": ""
      }
    })])])
  })) : _vm._e(), _vm._v(" "), (_vm.linkmanList) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.compileBtn
    }
  }, [_vm._v("确定")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "new-construction"
  }, [_c('span', {
    on: {
      "click": _vm.Construction
    }
  }, [_vm._v("新建联系人")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newConstruction),
      expression: "!newConstruction"
    }]
  }, [_c('h1', {
    staticClass: "LHeader"
  }, [_vm._v("添加联系人")]), _vm._v(" "), _c('div', {
    staticClass: "new-info"
  }, [_c('p', [_c('span', [_vm._v("姓名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConstructionArray.name),
      expression: "ConstructionArray.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ConstructionArray.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ConstructionArray.name = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "error"
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("手机")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConstructionArray.phone),
      expression: "ConstructionArray.phone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ConstructionArray.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ConstructionArray.phone = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "error"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "new-btn",
    on: {
      "click": _vm.newBtn
    }
  }, [_vm._v("提交")])])] : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('span', [_vm._v("张毅")]), _vm._v(" "), _c('span', [_vm._v("133****1333")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/redact.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('span', [_vm._v("张毅")]), _vm._v(" "), _c('span', [_vm._v("133****1333")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/redact.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('span', [_vm._v("张毅")]), _vm._v(" "), _c('span', [_vm._v("133****1333")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/redact.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('span', [_vm._v("张毅")]), _vm._v(" "), _c('span', [_vm._v("133****1333")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/redact.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-info"
  }, [_c('p', [_c('span', [_vm._v("姓名")]), _c('input', {
    attrs: {
      "type": "text"
    }
  }), _c('i', {
    staticClass: "error"
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("证件号码")]), _c('select', {
    staticClass: "Certificates"
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("身份证")]), _c('option', [_vm._v("护照")]), _c('option', [_vm._v("台胞证")]), _c('option', [_vm._v("回乡证")])]), _c('input', {
    staticClass: "identity",
    attrs: {
      "type": "text"
    }
  }), _c('i', {
    staticClass: "error"
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("护照号")]), _c('input', {
    attrs: {
      "type": "text"
    }
  }), _c('i', {
    staticClass: "error"
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("手机")]), _c('input', {
    attrs: {
      "type": "text"
    }
  }), _c('i', {
    staticClass: "error"
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("任职机构")]), _c('input', {
    attrs: {
      "type": "text"
    }
  }), _c('i', {
    staticClass: "error"
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("职务")]), _c('input', {
    attrs: {
      "type": "text"
    }
  }), _c('i', {
    staticClass: "error"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d986efa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/list.vue
// module id = 551
// module chunks = 1